export * from './newsletter-out-of-office-create.request';
//# sourceMappingURL=index.js.map